import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FiMenu, FiPhone, FiX } from "react-icons/fi";
import schoolLogo from "../../image/logo/Logo.png";

const navItems = [
  { label: "Home", to: "/homenew" },
  { label: "About", to: "/vision-and-mission" },
  { label: "Boarding Life", to: "/boarding" },
  { label: "Academics", to: "/curriculum" },
  { label: "Campus", to: "/infrastructure" },
  { label: "Admissions", to: "/admissionnew" },
  { label: "Life at Bhimtal", to: "/beyond-curricular" },
  { label: "Contact", to: "/contact-us" },
];

function AdmissionHeader() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const closeOnEscape = (event) => {
      if (event.key === "Escape") setOpen(false);
    };
    document.addEventListener("keydown", closeOnEscape);
    return () => document.removeEventListener("keydown", closeOnEscape);
  }, []);

  return (
    <header className="ad26-header">
      <div className="ad26-header-inner">
        <Link className="ad26-brand" to="/homenew" aria-label="HGS Bhimtal home">
          <img src={schoolLogo} alt="HGS Bhimtal crest" />
          <span>
            <strong>HGS Bhimtal</strong>
            <small>A school for a brighter tomorrow</small>
          </span>
        </Link>

        <button
          className="ad26-menu-button"
          type="button"
          aria-expanded={open}
          aria-controls="ad26-navigation"
          aria-label={open ? "Close navigation" : "Open navigation"}
          onClick={() => setOpen((current) => !current)}
        >
          {open ? <FiX aria-hidden="true" /> : <FiMenu aria-hidden="true" />}
        </button>

        <nav
          className={`ad26-nav ${open ? "ad26-nav-open" : ""}`}
          id="ad26-navigation"
          aria-label="Main navigation"
        >
          {navItems.map((item) => (
            <Link
              key={item.label}
              className={item.to === "/admissionnew" ? "ad26-nav-active" : ""}
              to={item.to}
              onClick={() => setOpen(false)}
            >
              {item.label}
            </Link>
          ))}
          <a className="ad26-nav-call" href="#enquire">
            <FiPhone aria-hidden="true" /> Enquire now
          </a>
        </nav>
      </div>
    </header>
  );
}

export default AdmissionHeader;
